import { createFileRoute } from '@tanstack/react-router';
import * as z from 'zod';

import Loading from '@/_pages/companies/new/loading';

export const Route = createFileRoute('/_private/companies/new')({
  validateSearch: (search) => z.object({ from: z.string().optional() }).parse(search),
  pendingComponent: Loading,
});
